import React from "react";
import styles from "../styles/Footer.module.css";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import logo from "../assets/images/churchLogo.png";
export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <img src={logo} alt="CWFM Logo" className={styles.logo} />
          <div className={styles.brandTitle}>CWFM</div>
          <div className={styles.brandDesc}>
            For the <b>Lord</b> has chosen <b>Calvary</b>, He has desired it for
            His dwelling, saying "This is my resting place for ever and ever;
            here I will sit enthroned, for I have desired it."
          </div>
        </div>
        <div className={styles.linksCol}>
          <div className={styles.linksHeader}>ABOUT</div>
          <a href="/about-us">About Us</a>
        </div>
        <div className={styles.linksCol}>
          <div className={styles.linksHeader}>MINISTRIES</div>
          <a href="/ministry">Kids Ministry</a>
          <a href="/ministry">Youth Ministry</a>
          <a href="/ministry">Women Ministry</a>
          <a href="/ministry">Men Ministry</a>
        </div>
        <div className={styles.linksCol}>
          <div className={styles.linksHeader}>CONTACT</div>
          <a href="/contact-us">Contact Us</a>
        </div>
        <div className={styles.newsletterCol}>
          <div className={styles.linksHeader}>NEWSLETTER</div>
          <form
            className={styles.newsletterForm}
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              type="email"
              placeholder="Email address"
              className={styles.newsletterInput}
            />
            <button className={styles.subscribeBtn}>Subscribe</button>
          </form>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.copyright}>
          Copyright &copy; {new Date().getFullYear()} <b>CWFM</b>. All rights
          reserved.
        </div>
        <div className={styles.socials}>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter />
          </a>
          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube />
          </a>
        </div>
      </div>
    </footer>
  );
}
